import React from 'react';
import Typography from 'carbon-react/lib/components/typography';

import { FormattedMessage } from '@futrli/localisation';


export const TechnicalIssuesCarbon = () => (
  <Typography fontSize="14px" color="errorRed">
    <FormattedMessage
      id="common.problem_technical_issues"
      defaultMessage="Oops, looks like we're having some technical issues. Please try again!"
    />
  </Typography>
);
